import { createFileRoute } from '@tanstack/react-router'
import ProductManagementPage from '@/components/Products'

export const Route = createFileRoute('/_authenticated/products/')({
  component: ProductManagement,
})

function ProductManagement() {
  return (
    <div>
      <ProductManagementPage />
    </div>
  )
}
